import { Mask } from "@/types/mask";

type SelecteMaskDetailsProps = {
  projectMasks: Mask[];
  selectedMaskId: string;
};
const SelectedMaskDetails = ({ projectMasks, selectedMaskId }: SelecteMaskDetailsProps) => {
  const selectedMask = projectMasks.find((m) => m.id === selectedMaskId);
  if (!selectedMask) return null;

  return (
    <div className="space-y-4">
      <div className="pb-3 border-b border-gray-200">
        <p className="text-sm font-medium text-gray-700 mb-1">Mask Name:</p>
        <p className="text-sm text-gray-900">{selectedMask.name}</p>
      </div>

      <div className="grid grid-cols-1 gap-3">
        <div>
          <p className="text-sm font-medium text-gray-700">Wafer Diameter:</p>
          <p className="text-sm text-gray-900">{selectedMask.waferDiameter || "Not specified"}</p>
        </div>

        <div>
          <p className="text-sm font-medium text-gray-700">PCM Version:</p>
          <p className="text-sm text-gray-900">{selectedMask.pcmVersion.pcmVersion}</p>
        </div>

        <div>
          <p className="text-sm font-medium text-gray-700">OTEST Version:</p>
          <p className="text-sm text-gray-900">{selectedMask.pcmVersion.oTestVersion}</p>
        </div>

        <div className="pt-2 border-t border-gray-100">
          <p className="text-sm font-medium text-gray-700 mb-2">Die Dimensions:</p>
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Die Width:</span>
              <span className="text-sm font-medium text-gray-900">
                {selectedMask.dieWidth ? `${selectedMask.dieWidth} µm` : "Not specified"}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Die Height:</span>
              <span className="text-sm font-medium text-gray-900">
                {selectedMask.dieHeight ? `${selectedMask.dieHeight} µm` : "Not specified"}
              </span>
            </div>
          </div>
        </div>

        <div className="pt-2 border-t border-gray-100">
          <p className="text-sm font-medium text-gray-700 mb-2">Die Offsets:</p>
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Offset X:</span>
              <span className="text-sm font-medium text-gray-900">
                {selectedMask.dieOffsetX !== undefined && selectedMask.dieOffsetX !== null
                  ? `${selectedMask.dieOffsetX} µm`
                  : "Not specified"}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Offset Y:</span>
              <span className="text-sm font-medium text-gray-900">
                {selectedMask.dieOffsetY !== undefined && selectedMask.dieOffsetY !== null
                  ? `${selectedMask.dieOffsetY} µm`
                  : "Not specified"}
              </span>
            </div>
          </div>
        </div>

        <div className="pt-2 border-t border-gray-100">
          <p className="text-sm font-medium text-gray-700 mb-2">Reference Die:</p>
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Reference X:</span>
              <span className="text-sm font-medium text-gray-900">
                {selectedMask.referenceDieX !== undefined && selectedMask.referenceDieX !== null
                  ? `${selectedMask.referenceDieX} µm`
                  : "Not specified"}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Reference Y:</span>
              <span className="text-sm font-medium text-gray-900">
                {selectedMask.referenceDieY !== undefined && selectedMask.referenceDieY !== null
                  ? `${selectedMask.referenceDieY} µm`
                  : "Not specified"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectedMaskDetails;
